import React, { Component } from "react";

export default class FOCQtyRenderor extends Component {
  constructor(props) {
    super(props);
    this.checkedHandler = this.checkedHandler.bind(this);
  }
  checkedHandler(event) {
    let checked = event.target.checked;
    let colId = this.props.column.colId;
    this.props.node.setDataValue(colId, checked);
  }
  onChange(evebt) {}
  render() {
    return (
      <>
        {this.props.data.product && this.props.data.foc && (
          <div>{this.props.value}</div>
        )}
      </>
    );
  }
}
